import combineBenchlingReducers from 'util/combineBenchlingReducers';

import {reduceComplexPolymerVersionUIs, ComplexPolymerVersionUIsState} from './reduceComplexPolymerUIs';

export interface ModbioUIState {
  complexPolymerVersionUIs: ComplexPolymerVersionUIsState;
}

export default combineBenchlingReducers<ModbioUIState>({
  complexPolymerVersionUIs: reduceComplexPolymerVersionUIs,
});
